export default __webpack_public_path__ + "static/media/bnb-mist.cd61bef8.png";